<div class="absolute inset-0 flex items-center justify-center p-4" role="dialog" aria-modal="true"
    aria-labelledby="groups-whats-new-title">
    <button type="button" class="absolute inset-0 bg-zinc-200/40 backdrop-blur-md dark:bg-zinc-900/60"
        (click)="dismiss()" aria-label="Dismiss what's new in Groups"></button>

    <section #panel tabindex="-1"
        class="whats-new-panel relative z-10 flex max-h-full w-full max-w-2xl flex-col overflow-hidden rounded-2xl primary-card-container focus:outline-none">

        <div class="flex shrink-0 items-start justify-between gap-3 border-b border-border px-4 py-3">
            <div class="min-w-0">
                <p
                    class="m-0 inline-flex items-center gap-x-1.5 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-medium text-accent">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-3.5"
                        aria-hidden="true">
                        <path d="M9.9 2.1 8.5 6.4 4.2 7.8l4.3 1.4L9.9 13.5l1.4-4.3 4.3-1.4-4.3-1.4Z" />
                        <path d="M18 14l-.7 2.2L15 17l2.3.8L18 20l.7-2.2L21 17l-2.3-.8Z" />
                    </svg>
                    What's new
                </p>
                <h2 id="groups-whats-new-title" class="mt-1 text-base font-semibold text-primary">Groups just got a lot
                    more useful</h2>
                <p class="mt-1 text-sm text-secondary">A quick tour of what you can do on this page.</p>
            </div>
            <button type="button" (click)="dismiss()"
                class="shrink-0 rounded-full bg-zinc-200 p-1.5 text-primary hover:bg-zinc-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600 dark:bg-zinc-600 dark:hover:bg-zinc-500"
                aria-label="Close what's new in Groups">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="size-5" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>

        <div class="h-1 shrink-0 bg-zinc-200 dark:bg-zinc-700" role="progressbar" aria-label="Tour progress"
            [attr.aria-valuenow]="current() + 1" aria-valuemin="1" [attr.aria-valuemax]="steps.length">
            <div class="h-full bg-primary transition-all duration-300" [style.width.%]="progressPct()"></div>
        </div>

        <div class="min-h-0 flex-1 overflow-y-auto px-4 py-5" aria-live="polite">
            <div class="flex flex-col gap-4 sm:flex-row sm:gap-6">
                <div
                    class="flex size-14 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-accent sm:size-16">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-7 sm:size-8"
                        aria-hidden="true">
                        @for (iconPath of step().iconPaths; track iconPath) {
                        <path [attr.d]="iconPath" />
                        }
                    </svg>
                </div>

                <div class="min-w-0 flex-1">
                    <p class="m-0 text-xs font-medium uppercase tracking-wide text-secondary">{{ stepCounter() }} · {{
                        step().label }}</p>
                    <h3 class="mt-1 text-lg font-semibold text-primary">{{ step().title }}</h3>
                    <p class="mt-1 text-sm text-secondary">{{ step().description }}</p>

                    <ul role="list" class="mt-4 flex flex-col gap-2">
                        @for (bullet of step().bullets; track bullet) {
                        <li class="flex items-start gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                                class="mt-0.5 size-4 shrink-0 text-accent" aria-hidden="true">
                                <path d="M20 6 9 17l-5-5" />
                            </svg>
                            <p class="m-0 text-sm text-primary">{{ bullet }}</p>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </div>

        <div class="flex shrink-0 flex-wrap items-center justify-between gap-3 border-t border-border px-4 py-3">
            <div class="flex items-center gap-1.5" role="group" aria-label="Tour steps">
                @for (tourStep of steps; track tourStep.id; let index = $index) {
                <button type="button" (click)="goTo(index)" [class]="stepDotClass(index)"
                    [attr.aria-current]="isCurrent(index) ? 'step' : null"
                    [attr.aria-label]="'Go to step ' + (index + 1) + ': ' + tourStep.label"></button>
                }
            </div>

            <div class="flex items-center gap-3">
                @if (!isFirst()) {
                <button type="button" (click)="back()" class="secondary-button text-primary">
                    Back
                </button>
                }
                <button type="button" (click)="next()" class="primary-button inline-flex items-center gap-x-1.5">
                    {{ isLast() ? 'Got it' : 'Next' }}
                    @if (!isLast()) {
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5" aria-hidden="true">
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                    </svg>
                    }
                </button>
            </div>
        </div>
    </section>
</div>
